import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomHeader from '../../shared/components/Headers/CustomHeader';

const HomeHeaderStyle = makeStyles({
  headerDimensions: {
    height: 50,
    width: '100%',
  },
  headerPaddingFull: {
    padding: '0px 10px',
    height: '100%',
  },
  titleSettings: {
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: 0,
    lineHeight: '20px',
    alignSelf: 'center',
    marginLeft: 8,
  },
});

/**
 * Componente de header que muestra el título del dashboard: Wholemeaning Apps
 */
const HomeHeader = () => {
  const classes = HomeHeaderStyle();
  const { t } = useTranslation('common');

  return (
    <CustomHeader>
      <Grid
        container={true}
        justify="space-between"
        className={classes.headerPaddingFull}
        alignItems="center"
      >
        <Grid item={true}>
          <Typography className={classes.titleSettings}>{t('apps')}</Typography>
        </Grid>
      </Grid>
    </CustomHeader>
  );
};

export default HomeHeader;
